import { CheckBox, DeleteRounded } from "@mui/icons-material";
import { Box, Button, Checkbox, Dialog, DialogActions, IconButton, MenuItem, Select, Stack, Typography, colors } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	converAttrToDatagridCol,
	imageTableColumn,
	styleImageColumn,
	statusOptions,
	publishColumns,
	inputTypes,
	createdByColumns,
	arrType,
	selectOptionsKeyName,
	styleFabricUpdationColumns,
} from "data/globalData";
import { attrGroupLinkedTables, getColDefaultValue, productionStageOptions, styleColorAssocObj } from "components/PimDashboard/data";
import moment from "moment";
import { useEffect, useState } from "react";
import { AuthState } from "context/AuthContext";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { attrValAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const FilterModal = ({
	modal,
	handleCloseModal,
	filterColumns,
	setFilterColumns,
	filterColumnVal,
	setFilterColumnVal,
	localStorageStr,
}) => {
	const { snackBar, setSnackBar, setSnackBarOpen } = GlobalState();
	const { setLoadingOpen } = GlobalState();
	const { setSelectedStyle, allAttributes } = PimDashboardState();
	const [filterColumnsState, setFilterColumnsState] = useState(filterColumns ?? []);
	const [filterValuesState, setFilterValuesState] = useState(filterColumnVal ?? {});
	const [attrToAdd, setAttrToAdd] = useState(inputTypes.SELECT.key);
	const { user } = AuthState();

	const handleClose = () => {
		handleCloseModal();
	};
	const handleClearFilterClick = async () => {
		setFilterColumnsState([]);
		setFilterValuesState({});
		setFilterColumns([]);
		setFilterColumnVal({});
		localStorage.removeItem(localStorageStr);
		handleClose();
	};
	const handleColumnAddClick = async () => {
		let attr = [
			...allAttributes,
			...createdByColumns,
			...Object.keys(publishColumns)?.map((row) => publishColumns[row]),
			...styleFabricUpdationColumns,
		].filter((row) => row.key === attrToAdd)?.[0];
		attr = { ...attr };
		console.log(attr, "ghsaddfghj");
		if (attr.key) {
			if (attr?.input_type === inputTypes.SELECT.key) attr["input_type"] = inputTypes.MULTIPLE_SELECT.key;
			setFilterValuesState({
				...filterValuesState,
				[attr.key]: getColDefaultValue(attr),
			});
			setFilterColumnsState([...filterColumnsState, attr]);
			setAttrToAdd(inputTypes.SELECT.key);
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Attribute not found`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const handleAttrDelete = (row) => {
		console.log(row, "gfdfhgjmk,");
		setFilterColumnsState(filterColumnsState?.filter((col) => row.key !== col.key));
		setFilterValuesState((prev) => {
			delete prev[row.key];
			return { ...prev };
		});
	};
	const handleApplyClick = async (e) => {
		if (!filterColumnsState?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `No Conditions to apply`,
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});

			return;
		}
		setFilterColumns(
			filterColumnsState?.reduce((acc, row) => {
				if (
					filterValuesState[row.key] !== undefined &&
					filterValuesState[row.key] !== null &&
					filterValuesState[row.key] !== "" &&
					!(Array.isArray(filterValuesState[row.key]) && filterValuesState[row.key].length === 0)
				) {
					acc.push(row);
				}
				return acc;
			}, []),
		);
		let obj = { ...filterValuesState };
		Object.keys(obj).forEach((key) => {
			if (obj[key] === undefined || obj[key] === null || obj[key] === "" || (Array.isArray(obj[key]) && obj[key].length === 0)) {
				delete obj[key];
			}
		});
		setFilterColumnVal(obj);
		localStorage.setItem(localStorageStr, JSON.stringify(obj));
		handleCloseModal();
	};

	return (
		<Dialog fullWidth maxWidth="sm" open={modal} onClose={handleClose}>
			<Box
				width="95%"
				margin="auto"
				pt={2}
				display="flex"
				flexWrap="wrap"
				columnGap={2}
				rowGap={1}
				// justifyContent="space-around"
			>
				<Typography width="100%" variant="h6">
					Filter
				</Typography>

				<Stack width="100%" spacing={2}>
					<Stack width={300}>
						<Typography>Add Attribute</Typography>
						<Box display="flex" columnGap={1} width="100%">
							<Select
								value={attrToAdd}
								onChange={(e) => setAttrToAdd(e.target.value)}
								fullWidth
								MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
								size="small"
								placeholder="">
								<MenuItem value={inputTypes.SELECT.key}>Select</MenuItem>
								{[
									...allAttributes,
									...createdByColumns,
									...Object.keys(publishColumns)?.map((row) => publishColumns[row]),
									...styleFabricUpdationColumns,
								]?.map((row) => {
									return (
										<MenuItem value={row?.key} key={row?.name}>
											{row?.["name"]}
										</MenuItem>
									);
								})}
							</Select>
							<Box>
								<Button variant="contained" onClick={handleColumnAddClick}>
									Add
								</Button>
							</Box>
						</Box>
					</Stack>

					<Stack width="100%" columnGap={1} rowGap={1} display="flex" flexWrap="wrap">
						{filterColumnsState?.map((originalRow, index) => {
							const row = { ...originalRow };
							let options = {};
							if (row?.input_type === inputTypes.SELECT.key || row?.input_type === inputTypes.MULTIPLE_SELECT.key) {
								row.input_type = inputTypes.MULTIPLE_SELECT.key;
								if (row?.linked_table)
									options = {
										type: arrType,
										list: row?.[attrValAssocObj]?.map((val) => ({ name: val?.value, key: val?.value })) ?? [],
									};
								else options = row[selectOptionsKeyName] ?? { type: arrType, list: [] };
							}

							if (row?.input_type === inputTypes.AUTO_GENERATE.key) {
								row.input_type = inputTypes.ENTER.key;
							}

							return (
								<Box key={index} display="flex" alignItems="center" width="100%">
									<RenderInputField
										width={"90%"}
										longWidth={"90%"}
										column={{ ...row, [selectOptionsKeyName]: options }}
										data={filterValuesState}
										setData={setFilterValuesState}
										selectOptObjName={selectOptionsKeyName}
										multiple={options?.list ? true : false}
									/>
									<IconButton variant="outlined" onClick={() => handleAttrDelete(row)}>
										<DeleteRounded />
									</IconButton>
								</Box>
							);
						})}
					</Stack>
				</Stack>

				<DialogActions sx={{ marginLeft: "auto" }}>
					<Button variant="outlined" onClick={handleClose}>
						Cancel
					</Button>
					<Button variant="outlined" onClick={handleClearFilterClick}>
						Remove Filter
					</Button>
					<Button
						autoFocus
						variant="contained"
						sx={{ mr: 1 }}
						onClick={handleApplyClick}
						disabled={filterColumnsState?.length === 0}>
						Apply Filter
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default FilterModal;
